module.exports = __webpack_public_path__ + "235bbb6c509f06e2a5ae4d1761d7262c.MP3";